module.exports = __webpack_public_path__ + "static/media/image2.72298846.svg";